<ng-container *ngIf="openFormServiceInformation">
  <div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
    <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
    <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
      <div class="flex flex-col gap-3 p-5 min-h-[250px]">
        <div class="flex justify-between items-center">
          <h1 class="text-lg font-bold leading-3">Por favor, insira as informações do atendimento finalizado.</h1>
        </div>

        <form class="flex flex-col gap-5" [formGroup]="formServiceInformation">
          <div class="w-full wrapper flex flex-col md:grid">
            <div class="form-group">
              <label class="block text-gray-700 text-sm font-bold mb-2"> Nº protocolo: </label>
              <input
                type="text"
                class="form-input appearance-none border rounded w-52 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="protocol"
              />
            </div>

            <div class="flex gap-5 mt-3">
              <div class="form-group">
                <label class="block text-gray-700 text-sm font-bold mb-2"> Nº protocolo externo: </label>
                <input
                  type="text"
                  class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  formControlName="externalProtocol"
                />
              </div>

              <div class="form-group">
                <label class="block text-gray-700 text-sm font-bold mb-2"> Status do atendimento: </label>
                <select
                  class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  formControlName="status"
                >
                  <option value="concluido 1º nivel">Concluído em 1º nível</option>
                  <option value="concluido 2º nivel">Concluído em 2º nível</option>
                  <option value="pendente operadora">Pendente | 2º nível operadora</option>
                  <option value="pendente áreas internas">Pendente | 2º nível áreas internas</option>
                  <option value="assuntos relacionados a RH cliente">Assuntos relacionados a RH cliente</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="block text-gray-700 text-sm font-bold mb-2 mt-6"> Observação sobre o atendimento: </label>
              <textarea
                class="appearance-none border rounded w-full py-6 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="observation"
                rows="4"
              ></textarea>
            </div>

            <div class="form-group flex items-center justify-center py-2">
              <button (click)="saveServiceInformation()" class="w-80 h-9 btn btn--secondary">
                Salvar observações do atendimento
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
